/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 */

function ContactForm(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */

	
	/* PRIVATE VARIABLES */
	var submitEnabled = true;
	var form;
	var recaptchaToken = null;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function showAlert(message) {
		alert(message);
	}
	
	
	function onFormSendSuccess(){
		$('.state.form', _this.container).hide();
		$('.state.success', _this.container).show();
		NavigationUtils.scrollToElement($('.state.success', _this.container));
		_this.resetForm();
	}
	
	
	function onFormSendError(errorCode){
		switch(errorCode) {
			case 1:
				// captcha
				showAlert('Chyba ověření reCAPTCHA kódu. Zkuste prosím znovu načíst stránku a odeslat formulář.');
				break;
				
			default:
				// default
				showAlert('Odeslání formuláře se nezdařilo. Zkuste to prosím znovu později.');
				break;
		}
		getRecaptchaToken();
	}

	
	function initFormHandler(){
		var messageFieldInvalid = 'Vyplňte prosím toto pole.';
		var messageFieldEmail = 'Vyplňte prosím e-mailovou adresu ve správném tvaru.';
		var messageFieldTopic = 'Zvolte prosím jednu možnost.';
		var messageFieldAgree = 'Pro odeslání formuláře je nutné souhlasit se zpracováním osobních údajů.';
		
		form.validate({
			rules: {
				name: {
					required: true
				},
				message: {
					required: true
				},
				topic: {
					required: true
				},
				email: {
					required: true
				},
				agree: {
					required: true
				}
			},
			messages: {
				name: {
					required: messageFieldInvalid
				},
				message: {
					required: messageFieldInvalid
				},
				topic: {
					required: messageFieldTopic
				},
				email: {
					required: messageFieldEmail,
					email: messageFieldEmail
				},
				agree: {
					required: messageFieldAgree
				}
			},
			
			submitHandler: function(f) {
				if(submitEnabled){
					submitEnabled = false;

					var data = form.serializeArray();
					data.push({name: "formAction", value: "submit"});
					data.push({name: "recaptchaToken", value: recaptchaToken});
					
					$.post('/contact-form', data, function(result){
						if(result.status === 1){
							onFormSendSuccess();
						} else {
							onFormSendError(result.errorCode);
							submitEnabled = true;
						}
					});
				}
			}
		});
	}
	
	
	function getRecaptchaToken(){
		grecaptcha.execute(recaptchaSiteKey, {action: 'contact_form'})
		.then(function (token) {
			recaptchaToken = token;
		});
	}
	

	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			form = $('form', _this.container);
			
			// init
			initFormHandler();
			
			// init recaptcha
			grecaptcha.ready(function () {
				getRecaptchaToken();
			});
			
			_this.inited = true;
		}
	};
	
	
	this.resetForm = function(){
		form[0].reset();
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
